var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-1294 1347.9 141.7 38.1",
    style: {
      enableBackground: "new -1294 1347.9 141.7 38.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-1180,1385.2 -1187,1385.2 -1194.9,1375.5 -1202.8,1385.2 -1209.8,1385.2 -1194.9,1367  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "-1194.9,1367 -1209.8,1348.7 -1202.8,1348.7 -1194.9,1358.5 -1187,1348.7 -1180,1348.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1238,1380.7c1,1.1,2.2,2.1,3.5,2.9c2.7,1.7,5.9,2.5,9.6,2.5c3.5-0.1,6.6-0.9,9.3-2.6 c2.7-1.6,4.8-3.9,6.3-6.8c1.5-2.9,2.2-6.2,2.2-9.9c0-3.5-0.7-6.7-2.1-9.6c-1.4-2.8-3.5-5.1-6.2-6.8c-2.6-1.7-5.8-2.5-9.5-2.5 c-22,0-13.8,32.3-28.6,32.3c-2.1,0-4-0.5-5.6-1.6c-1.6-1.1-2.8-2.6-3.7-4.6c-0.9-2-1.3-4.2-1.3-6.8c0-2.6,0.5-5,1.5-7 s2.3-3.6,3.9-4.7c1.6-1.1,3.4-1.6,5.3-1.6c2.1,0,4,0.6,5.6,1.7c1.6,1.1,2.8,2.6,3.7,4.6c0.1,0.3,0.2,0.6,0.3,0.9 c0.9-2.7,2-5.4,3.2-7.9c-1-1-2.1-1.9-3.3-2.7c-2.7-1.8-5.9-2.6-9.5-2.6c-3.5,0.1-6.6,0.9-9.3,2.6c-2.7,1.6-4.8,3.9-6.3,6.8 s-2.2,6.2-2.2,9.9c0,3.5,0.7,6.7,2.1,9.6c1.4,2.8,3.5,5.1,6.2,6.8c2.7,1.7,5.9,2.5,9.6,2.5c21.7-0.1,13.3-32.3,28.5-32.3 c2.1,0,4,0.5,5.6,1.6c1.6,1.1,2.8,2.6,3.7,4.6s1.3,4.2,1.3,6.8s-0.5,5-1.5,7s-2.3,3.6-3.9,4.7s-3.4,1.6-5.3,1.6 c-2.1,0-4-0.6-5.6-1.7s-2.8-2.6-3.7-4.6c-0.2-0.4-0.4-0.9-0.5-1.4C-1235.7,1375.3-1236.8,1378.1-1238,1380.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1287.1,1379.8h14.5c0,0,1.3,2.5,4.7,5.4h-26.1v-36.4h6.9V1379.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1152.3,1385.2l-11.1-13.6c3.9-1.7,7-5.3,7-10.9c0-7.9-7-12-12.1-12h-7l-4.7,5.8h9.5c4.9,0,7.3,2.7,7.3,6.2 s-2.2,6.2-7.2,6.2h-9.6l4.6,5.7h5.7l10.2,12.6H-1152.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.28faa376dcb3678dff0e1a1ee2462561.svg";
export { ForwardRef as ReactComponent };